export default __webpack_public_path__ + "static/media/label_end.f6b35cdf.svg";